// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false
};

export const URL_SERVICE = {
	LOCAL: {
		//BASE_URL: 'http://10.3.22.20:6201',
		BASE_URL: 'https://prp.netlinktrust.com',
		// BASE_URL: 'http://10.3.22.20:6201',
		// BASE_URL: 'http://Beanstalktest-env.cerwbardmv.ap-southeast-1.elasticbeanstalk.com'


		// DMS_UPLOAD_URL: 'http://10.6.4.59:5000/dms/file/upload', // DEV
		//DMS_DOWNLOAD_URL: http://10.6.4.61:5002/dms/file/download // DEV
		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		DMS_UPLOAD_URL: 'https://prp.netlinktrust.com/dms/file/upload', // PROD
		DMS_DOWNLOAD_URL: 'https://prp.netlinktrust.com/dms/file/download' // PROD
	},
	DEV: {
		// BASE_URL: 'http://localhost:4201'
		//BASE_URL: 'http://10.3.22.20:6201',
		// BASE_URL: 'http://10.3.22.20:6201',
		BASE_URL: 'https://prp.netlinktrust.com',
		// BASE_URL: 'http://Beanstalktest-env.cerwbardmv.ap-southeast-1.elasticbeanstalk.com'


		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		DMS_UPLOAD_URL: 'https://prp.netlinktrust.com/dms/file/upload', // PROD
		DMS_DOWNLOAD_URL: 'https://prp.netlinktrust.com/dms/file/download' // PROD
	},
	UAT: {
		// BASE_URL: 'http://10.3.22.20:5201'
		//BASE_URL: 'http://10.3.22.20:6201',
		// BASE_URL: 'http://10.3.22.20:6201',
		BASE_URL: 'https://prp.netlinktrust.com',

		// DMS_UPLOAD_URL: 'http://10.6.5.107:5000/dms/file/upload', // SIT2
		// DMS_DOWNLOAD_URL: 'http://10.6.5.107:5002/dms/file/download' // SIT2

		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		DMS_UPLOAD_URL: 'https://prp.netlinktrust.com/dms/file/upload', // PROD
		DMS_DOWNLOAD_URL: 'https://prp.netlinktrust.com/dms/file/download' // PROD
	},
	PROD: {
		// BASE_URL: 'https://api.plansalesnce.Netlink.com'//"Kowsalya: Text changed for NLT PRP portal development"
		//BASE_URL: 'http://10.3.22.20:6201',
		// BASE_URL: 'http://localhost:6201',
		BASE_URL: 'https://prp.netlinktrust.com',


		// DMS_UPLOAD_URL: 'http://10.6.5.107:5000/dms/file/upload', // SIT2
		// DMS_DOWNLOAD_URL: 'http://10.6.5.107:5002/dms/file/download', // SIT2

		// DMS_UPLOAD_URL: 'http://10.6.4.95:5000/dms/file/upload', // UAT
		// DMS_DOWNLOAD_URL: 'http://10.6.4.95:5002/dms/file/download' // UAT

		DMS_UPLOAD_URL: 'https://prp.netlinktrust.com/dms/file/upload', // PROD
		DMS_DOWNLOAD_URL: 'https://prp.netlinktrust.com/dms/file/download' // PROD
	}
};



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/environments/environment.ts